// extracted by mini-css-extract-plugin
module.exports = {"featured_games_results":"style_featured_games_results__bbrXz","no_results":"style_no_results__0Mp03","no_results_text":"style_no_results_text__nn5u7"};